<script lang="ts">
    import { Filters } from "./store";
    import BESTIARY from "./bestiary";

    let difficulties = [];

    BESTIARY.forEach(
        ({ difficulty }) => (difficulties = [...difficulties, difficulty])
    );
    difficulties = difficulties.sort((a, b) => a - b);
    let minDifficulty = difficulties[0];
    let maxDifficulty = difficulties[difficulties.length - 1];
    $: if (maxDifficulty < minDifficulty) maxDifficulty = minDifficulty;

    updateDifficultyFilter();

    function updateDifficultyFilter() {
        Filters.update((filter) => {
            filter.difficulty["min"] = minDifficulty;
            filter.difficulty["max"] = maxDifficulty;
            return filter;
        });
    }

    const difficultyOptions = new Set(difficulties);
</script>

<label
    >Difficulty
    <select bind:value={minDifficulty} on:change={updateDifficultyFilter}>
        {#each Array.from(difficultyOptions) as d}
            <option value={d}>{d}</option>
        {/each}
    </select>
    -
    <select bind:value={maxDifficulty} on:change={updateDifficultyFilter}>
        {#each Array.from(difficultyOptions) as d}
            {#if d >= minDifficulty}<option value={d}>{d}</option>{/if}
        {/each}
    </select>
</label>
